import React, { useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient"; // asegúrate de que esta ruta sea la tuya

const Hero = () => {
  const heroRef = useRef(null);
  const canvasRef = useRef(null);
  const [slidesData, setSlidesData] = useState([]);

  // 1) Traer slides desde la BD
  useEffect(() => {
    const fetchSlides = async () => {
      const now = new Date();

      const { data, error } = await supabase
        .from("hero_slides")
        .select("*")
        .eq("active", true)
        .order("position", { ascending: true });

      if (error) {
        console.error("Error cargando hero_slides:", error);
        return;
      }

      // filtrar por rango si tienen fechas
      const filtered = (data || []).filter((row) => {
        const startOk = !row.starts_at || new Date(row.starts_at) <= now;
        const endOk = !row.ends_at || new Date(row.ends_at) >= now;
        return startOk && endOk;
      });

      setSlidesData(filtered);
    };

    fetchSlides();
  }, []);

  // 2) Lógica de animación (la tuya) cuando ya hay slides
  useEffect(() => {
    const heroEl = heroRef.current;
    const canvas = canvasRef.current;
    if (!heroEl || !canvas) return;
    if (!slidesData.length) return; // espera a que haya slides

    const slides = heroEl.querySelectorAll(".slide");
    const dotsWrap = heroEl.querySelector(".dots");
    const prevBtn = heroEl.querySelector(".prev");
    const nextBtn = heroEl.querySelector(".next");
    const SLIDE_TIME = 5000;
    let current = 0;
    let intervalId;

    // limpiar dots viejos por si se recarga
    dotsWrap.innerHTML = "";

    // crear dots
    slides.forEach((_, i) => {
      const dot = document.createElement("div");
      dot.className = "dot";
      const progress = document.createElement("div");
      progress.className = "progress";
      dot.appendChild(progress);
      dot.addEventListener("click", () => goToSlide(i, true));
      dotsWrap.appendChild(dot);
    });
    const dots = heroEl.querySelectorAll(".dot");

    function typeText(el, text, speed = 30) {
      el.innerHTML = "";
      let i = 0;
      const timer = setInterval(() => {
        el.innerHTML = text.slice(0, i);
        i++;
        if (i > text.length) clearInterval(timer);
      }, speed);
    }

    function animateSlideText(slideEl) {
      const title = slideEl.dataset.title || "";
      const sub = slideEl.dataset.sub || "";
      const titleEl = slideEl.querySelector(".typed-title");
      const subEl = slideEl.querySelector(".typed-sub");
      const cta = slideEl.querySelector(".cta");

      // typing SOLO en título
      typeText(titleEl, title, 30);

      // subtítulo normal
      subEl.textContent = sub;

      setTimeout(() => cta && cta.classList.add("show"), 950);
    }

    function goToSlide(index) {
      slides.forEach((s, i) => s.classList.toggle("active", i === index));

      dots.forEach((d, i) => {
        const prog = d.querySelector(".progress");
        if (i === index) {
          prog.style.transition = "none";
          prog.style.width = "0%";
          void prog.offsetWidth;
          prog.style.transition = `width ${SLIDE_TIME}ms linear`;
          prog.style.width = "100%";
        } else {
          prog.style.transition = "none";
          prog.style.width = "0%";
        }
      });

      current = index;
      animateSlideText(slides[index]);

      clearInterval(intervalId);
      intervalId = setInterval(nextSlide, SLIDE_TIME);
    }

    function nextSlide() {
      goToSlide((current + 1) % slides.length);
    }

    prevBtn?.addEventListener("click", () => {
      const idx = (current - 1 + slides.length) % slides.length;
      goToSlide(idx);
    });

    nextBtn?.addEventListener("click", () => {
      const idx = (current + 1) % slides.length;
      goToSlide(idx);
    });

    // init
    goToSlide(0);
    intervalId = setInterval(nextSlide, SLIDE_TIME);

    // ====== partículas ======
    const ctx = canvas.getContext("2d");
    let w, h;
    const particles = [];
    const computed = getComputedStyle(document.documentElement);
    const formatRgbForCanvas = (value, fallback) => {
      const raw = (value || fallback || "").trim();
      if (!raw) return fallback;
      return raw.replace(/\s+/g, ",").replace(/,,+/g, ",");
    };

    const brandRgb = formatRgbForCanvas(
      computed.getPropertyValue("--brand-rgb"),
      "90,97,229"
    );
    const accentRgb = formatRgbForCanvas(
      computed.getPropertyValue("--accent-rgb"),
      "242,191,83"
    );

    let mouseX = -9999,
      mouseY = -9999;

    function resize() {
      const rect = heroEl.getBoundingClientRect();
      w = (canvas.width = rect.width);
      h = (canvas.height = rect.height);
    }
    window.addEventListener("resize", resize);
    resize();

    for (let i = 0; i < 160; i++) {
      particles.push({
        x: Math.random() * w,
        y: Math.random() * h,
        vx: (Math.random() - 0.5) * 0.7,
        vy: (Math.random() - 0.5) * 0.7,
        r: Math.random() * 2.3 + 0.5,
        color:
          Math.random() > 0.5
            ? `rgba(${brandRgb},0.9)`
            : `rgba(${accentRgb},0.9)`,
      });
    }

    let rafId;
    function draw() {
      ctx.clearRect(0, 0, w, h);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = w;
        if (p.x > w) p.x = 0;
        if (p.y < 0) p.y = h;
        if (p.y > h) p.y = 0;

        const dx = mouseX - p.x;
        const dy = mouseY - p.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 140) {
          const f = (140 - dist) / 140;
          p.x += dx * f * 0.03;
          p.y += dy * f * 0.03;
        }

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.shadowColor = p.color;
        ctx.shadowBlur = 14;
        ctx.fill();
      });
      rafId = requestAnimationFrame(draw);
    }
    draw();

    function onMove(e) {
      const rect = canvas.getBoundingClientRect();
      mouseX = e.clientX - rect.left;
      mouseY = e.clientY - rect.top;
    }
    heroEl.addEventListener("mousemove", onMove);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("resize", resize);
      heroEl.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(rafId);
    };
  }, [slidesData]); // 👈 se vuelve a montar la animación cuando llegan los slides

  // === Etiquetar forma de imagen para que el CSS ajuste tamaño ===
useEffect(() => {
  const heroEl = heroRef.current;
  if (!heroEl) return;

  const getShape = (img) => {
    const r = img.naturalWidth / img.naturalHeight;
    if (r > 1.15) return 'wide';     // ej. laptop
    if (r < 0.90) return 'tall';     // ej. perfume
    return 'square';                 // ej. cafetera
  };

  const tagImg = (img) => {
    const slide = img.closest('.slide');
    if (!slide || !img.naturalWidth) return;
    slide.dataset.shape = getShape(img);
  };

  const imgs = heroEl.querySelectorAll('.slide .image img');

  imgs.forEach((img) => {
    if (img.complete && img.naturalWidth) {
      tagImg(img);
    } else {
      const onLoad = () => tagImg(img);
      img.addEventListener('load', onLoad, { once: true });
    }
  });

  return () => {
    imgs.forEach((img) => img.onload = null);
  };
}, [slidesData]); 

  return (
    <section className="hero-energy" id="hero-energy" ref={heroRef}>
      <div className="bg-gradient"></div>
      <canvas id="dust-bg" ref={canvasRef}></canvas>

      <div className="slides">
        {slidesData.map((slide, i) => (
          <div
            key={slide.id}
            className={`slide ${i === 0 ? "active" : ""}`}
            data-title={slide.title}
            data-sub={slide.subtitle || ""}
          >
            <div className="text">
              <h1 className="typed-title"></h1>
              <p className="typed-sub"></p>
              {slide.cta_label && slide.cta_url ? (
                <a href={slide.cta_url} className="btn-primary cta">
                  {slide.cta_label}
                </a>
              ) : (
                <a
                  href="#"
                  className="btn-primary cta"
                  style={{ display: "none" }}
                >
                  {/* sin CTA */}
                </a>
              )}
            </div>
            <div className="image">
              <div className="glow"></div>
              <img src={slide.image_url} alt={slide.title} />
            </div>
          </div>
        ))}
      </div>

      <button className="nav glass prev">‹</button>
      <button className="nav glass next">›</button>
      <div className="dots"></div>
    </section>
  );
};

export default Hero;
